import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';

export interface ApiKey {
    id: number;
    /** First 8 characters. The full key is only ever returned by the create call. */
    shortKey: string;
    description: string | null;
    createdAt: string;
}

interface ApiKeysResponse {
    apiKeys: ApiKey[];
}

export const getQueryKey = (orgId?: number) => ['apikey', orgId] as const;

const useGetApiKeysQuery = (orgId?: number) => {
    return useQuery<ApiKey[], Error>({
        queryKey: getQueryKey(orgId),
        queryFn: async () => {
            const response = await get<ApiKeysResponse>('/v1.0/user/apikey');
            return response.data.apiKeys ?? [];
        },
        enabled: orgId !== undefined,
        gcTime: Infinity,
        placeholderData: [],
    });
};

export default useGetApiKeysQuery;
